// extracted by mini-css-extract-plugin
export default {"mapContainer":"ReservationSummary_mapContainer__LSeNO"};